var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidardocumentos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00dbdc;\r\n        opacity: .1;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #04808f;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.25,12.84l-3.5,3.45c-.21,.21-.48,.31-.76,.31s-.55-.1-.76-.32l-1.75-1.69,.64-.66,1.75,1.7c.06,.06,.17,.06,.22,0l3.5-3.45,.65,.66h0Zm-2.1,8.39h7.4v-.92h-7.4v.92Zm-3.7,0h1.85v-.92h-1.85v.92Zm3.7-12.02h7.4v-.92h-7.4v.92Zm-1.85-.92h-1.85v.92h1.85v-.92Zm12.95-2.31V25.85H5.75V5.96c0-1.27,1.04-2.31,2.31-2.31h13.87c1.27,0,2.31,1.04,2.31,2.31Zm-.92,0c0-.76-.62-1.39-1.39-1.39H8.06c-.76,0-1.39,.62-1.39,1.39V24.92H23.32V5.96ZM15,15.26h5.55v-.92h-4.61l-.94,.92Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15,
    cy: 14.75,
    r: 11.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidardocumentos);
export default __webpack_public_path__ + "static/media/Validardocumentos.b5a8673b72dd9f424d28f19d35af4bf1.svg";
export { ForwardRef as ReactComponent };